<template>
<v-flex
mt-2>
  <v-footer
    color="#0065BD"
    fixed
    dark
    height="auto"
  >
      <v-flex
        text-xs-center
        white--text
        xs12
      >
            <v-btn
        :to="{
          name: 'copyright'
        }"
        flat
        white--text
      >
        <strong> &copy;  2000 –  {{ currYear }}. IDS Publishing Corporation. All rights reserved.</strong>
      </v-btn>
      </v-flex>
  </v-footer>
  </v-flex>
</template>
<script>
export default {
	data: () => ({
		currYear: (new Date()).getFullYear()
	})
}
</script>=
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue